
define(
	'Eureka.MaxaPunchout.MaxaPunchout'
,   [
		'Eureka.MaxaPunchout.MaxaPunchout.View'
	]
,   function (
		MaxaPunchoutView
	)
{
	'use strict';

	return  {
		mountToApp: function mountToApp (container)
		{
			var checkout = container.getComponent('Checkout')
			checkout.addModuleToStep({
				step_url: 'billing',
				module: {
					id: 'MaxaPunchoutView',
					index: 6,
					classname: 'Eureka.MaxaPunchout.MaxaPunchout.View'
				}
			})

		}
	};
});
